
import Layout from '../../../layouts/main'
import { useState } from 'react';
import { toast } from 'react-toastify';
import config from '../../../../configuration/config.json'
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import cbor from 'borc';
import { Buffer } from 'buffer';

export default () => {
    const navigate = useNavigate();
    const [getDocumentStatus, setDocumentStatus] = useState([]);
    let isUpdateMode = false;
    var indexDocumentRowStatus = 1;

    return (
        <Layout>

            <div class="container-fluid mt-5">
                <div class='row'>
                    <h class='header1'>Document Status</h>
                </div>
                <div class="row">
                    <div class="form-group col-md-6  mt-3">
                        <input type="text" id="tbIssuerReferenceNumber" maxLength={50} class="textField" placeholder="Issuer Reference" aria-label="Issuer Reference" />
                    </div>
                    <div class="form-group col-md-6  mt-3">
                        <button type="button" onClick={searchStatus} class="primaryButton">Search</button>&nbsp;
                        <button type="button" onClick={updateDocument} class="primaryButton">Update</button>&nbsp;
                        <button type="button" onClick={deleteDocument} class="primaryButton">Delete</button>
                    </div>
                </div>

                <div class='row'>
                    <div class='col-12 mt-5'>
                        <table class="hidtable">
                            <thead class='tableTitle'>
                                <tr>
                                    <th scope="col">#</th>
                                    <th scope="col">Issuer Reference</th>
                                    <th scope="col">Status</th>
                                    <th scope="col">Action</th>
                                    <th scope="col">Message Type</th>
                                    <th scope="col">Event Occurred</th>
                                    <th scope="col"></th>
                                </tr>
                            </thead>
                            <tbody class='tableDataText'>
                                {
                                    getDocumentStatus.length > 0 ? (

                                        getDocumentStatus.map(document => (

                                            <tr class='tableRow'>
                                                <th scope="row">{indexDocumentRowStatus++}</th>
                                                <td class='textTransformNone'>{document.issuerReference}</td>
                                                <td>{document.status}</td>
                                                <td>{document.action}</td>
                                                <td class='textTransformNone'>{document.messageType}</td>
                                                <td>{document.eventOccurred}</td>
                                            </tr>

                                        ))) :

                                        <tr class='tableRow'>
                                            <td className='text-center tableDataText' colSpan="6">Enter inputs and search to proceed further...</td>
                                        </tr>
                                }

                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </Layout>
    );

    async function searchStatus() {
        document.getElementById('loadingProgressG').style.display = 'block';
        try {

            setDocumentStatus([]);
            let documentNumber = document.getElementById('tbIssuerReferenceNumber').value;
            if (documentNumber == null || documentNumber == "") {
                toast.error("IssuerReference is empty");
                document.getElementById('loadingProgressG').style.display = 'none';
                return;
            }
            documentNumber = documentNumber.trim();
            const response = await axios.request({
                method: 'GET',
                url: config.operatorportal.apibaseurl + 'document/configurations/issue/' + documentNumber,
                headers: { "content-type": "application/cbor", Authorization: `Bearer ${config.operatorportal.documentapijwttoken}` },
                responseType: 'arraybuffer',
                responseEncoding: 'binary'
            });

            if (response.status == 200) {

                if(isUpdateMode){
                    isUpdateMode = false;
                    navigate('/issuance/update/' + documentNumber);
                    return;
                }

                var documentStatusData = cbor.decode(new Buffer(response.data));

                let statusArray = [];
                statusArray.push(documentStatusData);
                setDocumentStatus(statusArray);
                document.getElementById('tbIssuerReferenceNumber').value = '';
                //document.getElementById('tbProvisionCode').value = '';
                document.getElementById('loadingProgressG').style.display = 'none';

            } else {
                var documentStatusData = cbor.decode(new Buffer(response.data));
                toast.error(documentStatusData);
                setDocumentStatus([]);
                document.getElementById('loadingProgressG').style.display = 'none';
            }
          
        } catch (error) {
            if(error.response?.data != undefined){
                let documentStatusData = cbor.decode(new Buffer(error.response.data));
                toast.error(documentStatusData.message);
                document.getElementById('loadingProgressG').style.display = 'none';
                return;
            }
            toast.error(error.message);
            document.getElementById('loadingProgressG').style.display = 'none';
        }


    }

    async function deleteDocument() {
        document.getElementById('loadingProgressG').style.display = 'block';
      
        try {
            setDocumentStatus([]);
            let documentNumber = document.getElementById('tbIssuerReferenceNumber').value;
            if (documentNumber == null || documentNumber == "") {
                toast.error("IssuerReference is empty");
                document.getElementById('loadingProgressG').style.display = 'none';
                return;
            }
            documentNumber = documentNumber.trim();
            const response = await axios.request({
                method: 'DELETE',
                url: config.operatorportal.apibaseurl + 'document/configurations/issue/'+ documentNumber,
                headers: { "content-type": "application/cbor", Authorization: `Bearer ${config.operatorportal.documentapijwttoken}` },
                responseType: 'arraybuffer',
                responseEncoding: 'binary'
            });
            
            if (response.status == 204) {
                toast.success('Document deleted successfully');
                setDocumentStatus([]);
                document.getElementById('tbIssuerReferenceNumber').value = '';
                document.getElementById('loadingProgressG').style.display = 'none';

            } else {
                var documentStatusData = cbor.decode(new Buffer(response.data));
                toast.error(documentStatusData); setDocumentStatus([]);
                document.getElementById('loadingProgressG').style.display = 'none';
            }

        } catch (error) {
            
            if(error.response?.data != undefined){
           
                let documentStatusData = cbor.decode(new Buffer(error.response.data));
                toast.error(documentStatusData.message);
                document.getElementById('loadingProgressG').style.display = 'none';
                return;
            }
            toast.error(error.message);
            document.getElementById('loadingProgressG').style.display = 'none';
        }


    }

    function updateDocument() {
        isUpdateMode = true;
        searchStatus();
    }

}


